import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WineIcon, PaletteIcon, SparklesIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <WineIcon className="w-8 h-8 text-wine" data-id="element-192" />,
    title: 'Your Bottle',
    description: 'Craft your style of bottle along with your wine variety and wine region. We take care of the rest.'
  }, {
    icon: <PaletteIcon className="w-8 h-8 text-wine" data-id="element-193" />,
    title: 'Your Label',
    description: 'Customize your design, give us a theme. We take care of the rest.'
  }, {
    icon: <SparklesIcon className="w-8 h-8 text-wine" data-id="element-194" />,
    title: 'Your Luxury',
    description: 'Enjoy your own wine as if it was yours and admire your label on your table. We take care of the rest.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-197">
          <span className="text-wine font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-198">
            The Experience
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl text-charcoal font-bold mb-6" data-id="element-199">
            Your Bottle, Your Label,{' '}
            <span className="italic text-wine font-normal" data-id="element-200">Your Luxury</span>
          </h2>
          <p className="text-lg text-brown/70" data-id="element-201">
            Three simple steps to create your personalized wine experience. From
            vineyard selection to your table.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-202">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-0.5 bg-cream-200 -z-10" data-id="element-203"></div>

          {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="relative flex flex-col items-center text-center group" data-id="element-204">
              {/* Number Badge */}
              <div className="absolute -top-3 -right-3 md:right-auto md:left-1/2 md:ml-6 w-8 h-8 bg-gold text-white rounded-full flex items-center justify-center font-bold text-sm z-10 shadow-md" data-id="element-205">
                {index + 1}
              </div>

              {/* Icon Circle */}
              <div className="w-24 h-24 bg-cream rounded-full flex items-center justify-center mb-6 shadow-subtle group-hover:scale-110 transition-transform duration-300 border border-wine/5" data-id="element-206">
                {step.icon}
              </div>

              <h3 className="font-playfair text-2xl font-bold text-charcoal mb-4" data-id="element-207">
                {step.title}
              </h3>
              <p className="text-brown/70 leading-relaxed max-w-xs" data-id="element-208">
                {step.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}